var _rect, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCenters(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 96,
    height: 97,
    viewBox: "0 0 96 97",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 0.5,
    width: 96,
    height: 96,
    rx: 8,
    fill: "#E3EEF1"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M48 51.3599C51.4463 51.3599 54.24 48.5661 54.24 45.1199C54.24 41.6736 51.4463 38.8799 48 38.8799C44.5538 38.8799 41.76 41.6736 41.76 45.1199C41.76 48.5661 44.5538 51.3599 48 51.3599Z",
    stroke: "#202224",
    strokeWidth: 1.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M31.24 41.48C35.18 24.16 60.84 24.18 64.76 41.5C67.06 51.66 60.74 60.26 55.2 65.58C51.18 69.46 44.82 69.46 40.78 65.58C35.26 60.26 28.94 51.64 31.24 41.48Z",
    stroke: "#202224",
    strokeWidth: 1.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCenters);
export default __webpack_public_path__ + "static/media/centers.0efedc5d5be176b7550d7f4873daa19a.svg";
export { ForwardRef as ReactComponent };